export enum InteriorType {
  RACK = "RACK",
  RACK19 = "RACK19",
  CASE = "CASE",
}
